// SO: This doesn't provide much but I found it difficult to set up conditional table columns in
// a non-awkward way
export function createTableColumns(columns) {
    return columns.filter(candidate => candidate && typeof candidate === 'object');
}
